import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdvanceSymbolSearchComponent } from './advance-symbol-search.component';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';



@NgModule({
  declarations: [
    AdvanceSymbolSearchComponent
  ],
  imports: [
    CommonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatListModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule
  ],
  exports: [
    AdvanceSymbolSearchComponent
  ]
})
export class AdvanceSymbolSearchModule { }
